angular.module('picmonic-common').directive('picmonicThumbnail', [
  '$timeout',
  '$state',
  '$location',
  'UserService',
  '$rootScope',
  function ($timeout, $state, $location, UserService, $rootScope) {
    return {
      restrict: 'E',
      scope: {
        picmonic: '=',
        goto: '@',
        size: '@',
        hidePlay: '=',
        icon: '@',
        highlightFact: '=',
      },
      template: `<div class="picmonic-thumbnail">
            <div ng-if="lock && !TokenService.values.tokens" class="trial-lock">
              <i class="material-icons pls-font-32">lock</i>
            </div>
            <fact-character-group 
                fact="highlightFact" 
                ng-if="highlightFact && !(picmonic.is_mature && UserService.user.safety_mode)" 
                player-service="{assetStatus: [], mode:'learn'}" 
                show-character-group="true" 
                pulse="true">
            </fact-character-group>
            <img 
                lazy-load="{{cdn_url}}/{{directory}}/{{picmonic.background ? picmonic.background : picmonic.main_image}}" 
                class="img-responsive" 
                ng-if="!picmonic.is_mature || !UserService.user.safety_mode"
            />
            <img 
                ng-if="picmonic.is_mature && UserService.user.safety_mode"
                lazy-load="{{base_asset_url}}/assets/img/mature-content-small-v3.svg" 
                class="img-responsive mature-picmonic" 
            />
            <div ng-if="!lock" class="card-icon" 
                 ng-if="hidePlay != true && (goto == 'none' || goto == 'app.learn' || $state.current.name=='app.learn')">
              <i class="material-icons i-play">{{icon}}</i>
            </div>
          </div>`,
      controller: [
        '$scope',
        'UserService',
        'MarketOptionsConfig',
        'TokenService',
        function ($scope, UserService, MarketOptionsConfig, TokenService) {
          $scope.UserService = UserService;
          $scope.TokenService = TokenService;
          $scope.trialPicmonics = MarketOptionsConfig.getMarketById(UserService.user.lead).free_trial_picmonics || [];
          $scope.lock =
            UserService.user.is_trial &&
            !$scope.picmonic.is_free &&
            !$scope.picmonic.is_owned &&
            $scope.picmonic.entity_type_id == 2 &&
            (!$scope.trialPicmonics.includes(String($scope.picmonic.card_id)) ||
              UserService.user.free_trial_expiration < Date.now() / 1000);
        },
      ],
      link: function (scope, element) {
        scope.$state = $state;

        scope.cdn_url = $rootScope.cdn_url;
        scope.base_asset_url = $rootScope.base_asset_url;

        if (!scope.icon) {
          scope.icon = 'play_arrow';
        }

        if (scope.goto != 'none') {
          scope.goto = 'app.learn';
        }

        function setDimensions() {
          //determine the font-size and line-height of the card icon
          var font_size = element.find('.card-icon').width() / 1.2;
          element.find('.card-icon').css({
            'font-size': font_size + 'px',
            'line-height': element.find('.card-icon').height() + 'px',
            'z-index': 100,
          });
        }

        switch (scope.size) {
          case 'full':
            scope.directory = 'images_panel';
            break;
          case 'medium':
            scope.directory = 'images_panel_tablet';
            break;
          case 'small':
            scope.directory = 'images_panel_mobile';
            break;
          default:
            scope.directory = 'images_panel_thumb';
            break;
        }

        $timeout(setDimensions, 100);
        angular.element(window).resize(setDimensions);

        element.bind('click', function (event) {
          send_ga('event', 'Picmonic Thumbnail', 'Clicked');

          if (scope.goto != 'none') {
            scope.$apply(function () {
              $state.go(scope.goto, { slug: scope.picmonic.slug });
            });
          }
        });
      },
    };
  },
]);
